module.exports = __webpack_public_path__ + "img/2.c3de3bae.png";